import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({location, match}) => (
  <section className="hero is-light">
    <div className="hero-body">
      <div className="container has-text-centered">
        <p className="title">
          Prefiksi
        </p>
        <p className="subtitle">
          Vežbanje
        </p>
      </div>
    </div>

    <div className="hero-foot">
      <nav className="tabs is-boxed is-centered">
        <div className="container">
          <ul>
            <li className={ location.pathname === '/exercise' ? "is-active" : undefined }>
              <Link to={match.path}>Vežbanje</Link>
            </li>
            <li className={ location.pathname === '/exercise/stats' ? "is-active" : undefined }>
              <Link to={`${match.path}/stats`}>Statistika</Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </section>
)

export default Hero;
